import { gql } from '@apollo/client';

export const ProductFragment = gql`
  fragment Product on Product {
    id
    name
  }
`;
